import retinajs from "retinajs";
import 'simplebar';
import { scrollToId } from "./scrollToId";
import tippy from "tippy.js";

import "./import/modules";
import "./import/components";
import "./faq";
import "./scrollAnimate";

function setDefaultFontSize () {

  const localStorage = window.localStorage
  if (localStorage.getItem('tc_increased_fs') === 'true') {
    document.documentElement.classList.add('increased-fs')
  } else {
    document.documentElement.classList.remove('increased-fs')
  }
}

function setContrastTheme () {
  const localStorage = window.localStorage
  const hightContrastTheme = localStorage.getItem('tc_contrast_theme')
  if (hightContrastTheme === 'true') {
    document.documentElement.classList.add('contrast-theme')
    setDefaultFontSize()
  } else {
    document.documentElement.classList.remove('contrast-theme')
  }
}


setContrastTheme()

document.addEventListener('DOMContentLoaded', () => {
  scrollToId()
  retinajs;
  tippy('[data-tippy-content]')
})
